import React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import i18n from "../i18n";
import {withTranslation} from "react-i18next";
import Draggable from "react-draggable";
import {Cookies} from "react-cookie";
import Constants from "../configs/Constants";

const cookie = new Cookies();
let counter = 0;
let countDown;
export var showMessageBox = function (
    _message,
    _title = i18n.t("common.message.title")
) {
    this.setState({
        open: true,
        color: "modal-primary",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        defaultPosition : {x : 0 , y : 0}
    });

};

export var showMessageBoxCountDown = function (
    _message,
    _timeCountDown,
    _title = i18n.t("common.message.title")
) {
    this.setState({
        open: true,
        color: "modal-primary",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        defaultPosition : {x : 0 , y : 0},
        isCountDown : true
    });
    counter = 0;
    countDown = undefined;
    this.timeDown = undefined;
    if(this.state.isCountDown){
        this.countDownFc(_timeCountDown);
    }

};

export var showErrorBox = function (
    _message,
    _title = i18n.t("common.message.title")
) {
    this.setState({
        open: true,
        color: "modal-danger",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        defaultPosition : {x : 0 , y : 0}
    });

};

export var showWarningBox = function (
    _message,
    _title = i18n.t("common.message.title")
) {
    this.setState({
        open: true,
        color: "modal-warning",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        defaultPosition : {x : 0 , y : 0}
    });
};

export var showConfirm = function (
    _message,
    _onConfirm,
    _title = i18n.t("common.confirm")
) {
    this.setState({
        open: true,
        color: "modal-primary",
        showConfirmBtn: true,
        title: _title,
        message: _message,
        onConfirm: _onConfirm,
        defaultPosition : {x : 0 , y : 0}
    });
};

class MessageBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            showConfirmBtn: false,
            isCountDown : false
        };
        this.interval = undefined;
        this.timeDown = undefined;
        showMessageBox = showMessageBox.bind(this);
        showErrorBox = showErrorBox.bind(this);
        showWarningBox = showWarningBox.bind(this);
        showConfirm = showConfirm.bind(this);
        showMessageBoxCountDown = showMessageBoxCountDown.bind(this)
    }

    onClose = () => {
        this.setState({open: false});
        this.setState({open: false});
        this.setState({isCountDown: false});
        if(cookie.get(Constants.STORAGE_KEY.SESSION_EXPIRED)){
            cookie.remove(Constants.STORAGE_KEY.SESSION_EXPIRED, {path: '/'});
            window.location.href="/sso/Login/"
        }
    };

    onConfirm = () => {
        this.setState({open: !this.state.open});
        this.setState({isCountDown: !this.state.open});
        this.state.onConfirm();
    };

    savePosition = (e, data) => {
        this.setState({
            defaultPosition : { x: data.x, y: data.y }
        })
    }
    startTimer = (duration, display) => {
        this.timeDown = duration;
        let minutes, seconds;
        this.interval = setInterval(()=> {
            minutes = parseInt(this.timeDown / 60, 10)
            seconds = parseInt(this.timeDown % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds;
            this.timeDown = this.timeDown -1 ;
            if (this.timeDown === 0) {
                this.onClose();
                clearInterval(this.interval);
            }
        }, 1000);
    }
    countDownFc = (timeCountDown) => {
        if (counter === 0) {
            let display = document.querySelector('#timer');
            if(display) {
                this.timeDown = undefined;
                clearInterval(this.interval);
                this.interval = undefined;
                countDown = this.startTimer(timeCountDown, display);
                counter++;
            }
        } else {
            counter++;
        }
    }
    // Also don't forget this

render() {
        const {t} = this.props;
        return (
            <div>
                <Draggable handle=".modal-header"
                           defaultPosition={{x: 0, y: 0}}
                           position={this.state.defaultPosition}
                           onStop={(e, data) => this.savePosition(e, data)}>
                    <Modal
                        isOpen={this.state.open}
                        toggle={this.onClose}
                        className={this.state.color}
                    >
                        <ModalHeader toggle={this.onClose}>{this.state.title}</ModalHeader>
                        <ModalBody>{this.state.message}</ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={this.onConfirm}
                                hidden={!this.state.showConfirmBtn}
                            >
                                {t("common.confirm")}
                            </Button>
                            <Button color="secondary" onClick={this.onClose}>
                                {t("common.close")}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Draggable>
            </div>
        );
    }
}

export default withTranslation()(MessageBox);
